module.exports = __webpack_public_path__ + "static/media/warehouse.05b6135c.svg";